import type { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  ChatRequest,
  ChatResponse,
  ChatSendMessageRequest,
} from "./api.dto";
import { useApi } from "@/shared/api";
import { useMutate } from "@/shared/hooks";

export const useGetChatWithCandidate = ({ candidateId }: ChatRequest) => {
  const { api } = useApi();

  return useQuery<ChatResponse>({
    queryKey: ["chat", candidateId],
    queryFn: async () => {
      try {
        const response = await api.get(
          `/recruit-chats/candidate/${candidateId}`,
        );

        return response.data;
      } catch (e) {
        console.warn(e);
      }
    },
  });
};

export const useSendMessageToCandidate = ({
  chatId,
  candidateId,
}: ChatSendMessageRequest) => {
  const { mutationFn, onSuccess, onError } = useMutate({
    method: "post",
    url: `/recruit-chats/${chatId}/reply?candidateId=${candidateId}`,
    toast: {
      success: { title: "Сообщение успешно отправлено", description: "" },
      error: { title: "Не удалось отправить сообщение", description: "" },
    },
  });

  return useMutation<
    AxiosResponse,
    AxiosError,
    { message: string },
    { message: string }
  >({
    mutationKey: ["sendMessage", chatId],
    mutationFn,
    onSuccess,
    onError,
  });
};
